<template>
  <UsuarioForm is-admin @close="$emit('close')" />
</template>

<script>
import UsuarioForm from "@/pages/configuracoes/usuario/UsuarioForm";

export default {
  name: "UsuarioAdminForm",
  components: {
    UsuarioForm
  }
};
</script>
